import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { classNames } from '../../util/classnames';
import { getSpanLineColor } from '../topological.editor.map/map.line/map.line';
import {
	type PoleAccuracy,
	poleMeasurementAccuracyTypes,
	TopologicalEditorPointCSS,
} from '../topological.editor.map/map.point/map.point';
import { CSS, Style } from './map.mode.legend.style';

addStyles(Style);

interface LegendItems {
	icon: MithrilVNode;
	text: T;
}

function lineIcon(color: string): MithrilVNode {
	return m('div', { className: CSS.legendIconLine, style: `background-color: ${color}` });
}

function pointIcon(accuracy: PoleAccuracy, selected: boolean = false): MithrilVNode {
	return m('div', {
		className: classNames(TopologicalEditorPointCSS.container, poleMeasurementAccuracyTypes[accuracy], {
			[TopologicalEditorPointCSS.isSelected]: selected,
		}),
	});
}

const legendItems: LegendItems[] = [
	{
		icon: lineIcon(getSpanLineColor('dropspan')),
		text: T.MAPMODE_LEGEND_DROPSPAN,
	},
	{
		icon: lineIcon(getSpanLineColor('anchor')),
		text: T.MAPMODE_LEGEND_ANCHOR,
	},
	{
		icon: lineIcon(getSpanLineColor('span')),
		text: T.MAPMODE_LEGEND_SPAN,
	},
	{
		icon: lineIcon(getSpanLineColor('unknown')),
		text: T.MAPMODE_LEGEND_UNKNOWN,
	},
	{
		icon: m(
			'div',
			{ className: classNames(TopologicalEditorPointCSS.title, CSS.legendCollectionLabelOverride) },
			'abc'
		),
		text: T.MAPMODE_LEGEND_COLLECTION_LABEL,
	},
	{
		icon: pointIcon('rtk_fixed', true),
		text: T.MAPMODE_LEGEND_SELECTED_COLLECTION,
	},
	{
		icon: pointIcon('rtk_fixed'),
		text: T.MAPMODE_LEGEND_LOCATION_RTK_FIXED,
	},
	{
		icon: pointIcon('edited'),
		text: T.MAPMODE_LEGEND_LOCATION_REVIEWED,
	},
	{
		icon: pointIcon('rtk_float'),
		text: T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT,
	},
	{
		icon: pointIcon('low'),
		text: T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY,
	},
];

export const MapModeLegend = {
	view() {
		return m(
			'div',
			{ className: CSS.container },
			legendItems.map((item) =>
				m('div', { className: CSS.legendItem }, [
					m('div', { className: CSS.legendIcon }, item.icon),
					m('div', { className: CSS.legendText }, Translate(item.text)),
				])
			)
		);
	},
};
